export default {
    carbonCredit: {
        view: 'Lihat',
        edit: 'Edit',
        back: 'Kembali',
        preview: 'Pratinjau',
        confirm: 'Konfirmasi',
        cancel: 'Batal',
        dashboard: 'Dasbor',
        select: 'Pilih',
        submit: 'Kirim',
        save: 'Simpan',
        title: 'Kredit Karbon',
        projects: 'Proyek',
        carbonProjectCredits: 'Kredit Proyek Karbon',
        carbonCreditProjects: 'Proyek Kredit Karbon',
        exportAs: 'Ekspor sebagai',
        downloadAsCSV: 'Unduh sebagai CSV',
        downloadAsExcel: 'Unduh sebagai Excel',
        downloadAsPDF: 'Unduh sebagai PDF',
        registerNewProject: 'Daftar Proyek Baru',
        creditInfo: '*Ini adalah perkiraan jumlah kredit. Jumlah kredit yang sebenarnya mungkin berbeda setelah verifikasi.',
        search: 'Cari',
        projectTitle: 'Judul Proyek',
        projectType: 'Jenis Proyek',
        country: 'Negara',
        totalCreditsGenerated: 'Total Kredit yang Dihasilkan',
        status: 'Status',
        descriptionPlaceholder: "Silakan berikan deskripsi proyek termasuk tujuan",
        filePreviewNotAvailable: 'Pratinjau file tidak tersedia untuk jenis file ini',
        active: 'Aktif',
        inactive: 'Tidak Aktif',
        pending: 'Menunggu',
        proposed: 'Diusulkan',
        planned: 'Direncanakan',
        inProgress: 'Sedang Berlangsung',
        operational: 'Operasional',
        deactivated: 'Dinonaktifkan',
        avoidedDeforestation: 'Deforestasi yang Dihindari',
        agroForestry: 'Agroforestri',
        forestry: 'Kehutanan',
        regenerativeAgriculture: 'Pertanian Regeneratif',
        agroforestry: 'Agroforestri',
        regenerative_agriculture: 'Pertanian Regeneratif',
        projectDeletedSuccessfully: 'Proyek berhasil dinonaktifkan',
        projectUpdatedSuccessfully: 'Proyek berhasil diperbarui',
        projectRegisteredSuccessfully: 'Proyek berhasil didaftarkan',
        deactivateProjectError: 'Error menonaktifkan proyek',
        deactivate: 'Nonaktifkan',
        deactivateProject: 'Nonaktifkan Proyek',
        deactivateConfirmation: 'Apakah Anda yakin ingin menonaktifkan proyek ini?',
        registerProject: 'Daftar Proyek Baru',
        editProject: 'Edit Proyek',

        register: { 
            title: 'Daftar Proyek',
            editTitle: 'Edit Proyek',
            projectTitle: 'Judul Proyek',
            projectType: 'Jenis Proyek',
            description: 'Deskripsi',
            selectCountry: "Pilih Negara",
            selectOrganization: 'Pilih Organisasi',
            status: 'Status',
            creditType: 'Jenis Kredit',
            creditStart: 'Mulai Kredit',
            creditEnd: 'Akhir Kredit',
            standardMethodology: 'Standar/Metodologi',
            validationDocumentation: 'Dokumentasi Validasi',
            vintage: 'Vintage',
            currency: 'Mata Uang',
            projectInfo: 'Informasi Proyek',
            organizationDetails: 'Detail Organisasi',
            attachmentTitle: 'Lampiran',
            attachmentInfo: 'Anda dapat menambahkan dokumen tambahan, gambar, video dan file audio yang relevan dengan proyek',
            documentation: 'Dokumentasi',
            sdgsTitle: 'Tujuan Pembangunan Berkelanjutan (SDGs)',
            sdgsInfo: 'Silakan pilih hanya tujuan yang relevan untuk proyek spesifik ini. Organisasi akan memiliki akses untuk melihat hanya tujuan yang terkait dengan proyek ini.',
            dataCollectionTitle: 'Siklus Pengumpulan Data',
            dataCollectionInfo: 'Untuk berpartisipasi dalam Program Kredit Karbon, petani harus menyediakan data historis pertanian selama pendaftaran dan terus mengirimkan pembaruan data berkala selama program tetap aktif. Ini memastikan pelacakan kinerja karbon yang akurat dari waktu ke waktu.',
            vintageYear: 'Tahun Vintage',
            estimatedCredit: 'Kredit Estimasi',
            pricePerCredit: 'Harga Per Kredit',
            moduleName: 'Nama Modul',
            futureData: 'Pengumpulan Data Berulang Masa Depan',
            score: 'Skor',
            approval: 'Persetujuan',

            projectAgreement: 'Perjanjian Proyek',
            headerImage: 'Gambar Header',
            headerImageInfo: '(Ukuran gambar header 1920 x 420 piksel. Gambar default akan diganti dengan gambar baru yang Anda unggah)',
            headerImagePlaceholder: "Gambar Header Default",
            responsibleDimitraOffice: 'Kantor Dimitra yang Bertanggung Jawab',
            selectDimitraOffice: 'Pilih Kantor Dimitra',
            makeASelection: 'Buat Pilihan',
            addNewDimitraOffice: 'Tambah Kantor Dimitra Baru',
            officeName: 'Nama Kantor',
            contactPerson: 'Nama Kontak',
            phoneNumber: 'Nomor Telepon',
            email: 'Email',
            address: 'Alamat',
            officeNameRequired: 'Nama kantor diperlukan',
            contactPersonRequired: 'Nama kontak diperlukan',
            addressRequired: 'Alamat diperlukan',
            phoneNumberRequired: 'Nomor telepon diperlukan',
            phoneNumberInvalid: 'Nomor telepon tidak valid',
            phoneNumberLength: 'Nomor telepon harus minimal 10 digit',
            selectVintage: 'Pilih Vintage',
            officeAddedSuccessfully: 'Kantor Dimitra berhasil ditambahkan',
            errorAddingOffice: 'Error menambahkan kantor Dimitra',
            searchOrganizations: 'Cari Organisasi',
            searchOrganizationsPlaceholder: 'Cari berdasarkan nama organisasi...',
            noOrganizationsFound: 'Tidak ada organisasi ditemukan',
            selectedOrganizations: 'Organisasi yang Dipilih',
            errorNegative: 'tidak boleh negatif.',
            errorRequiredField: '{field} diperlukan.',
            errorOrganizationRequired: 'Setidaknya satu organisasi harus dipilih.',
            errorVintageRequired: 'Setidaknya satu entri vintage diperlukan.',
            errorVintageFieldsRequired: 'Semua field vintage (tahun, kredit, harga) diperlukan.',
            allOrganizations: 'Semua Organisasi',
            removal: 'Penghapusan',
            avoided: 'Dihindari',
            mandatory: 'Wajib',
            scoreValidationError: 'Skor tidak valid untuk modul "{module}". Skor harus berupa bilangan bulat 0 atau lebih besar.',
            approvalValidationError: 'Persetujuan tidak valid untuk modul "{module}". Persetujuan harus berupa bilangan bulat antara 0 dan 100.',
            saveError: 'Gagal menyimpan proyek',
            fileUploadFailed: 'Gagal Mengunggah File',
            unsupportedFileFormat: 'Format file tidak didukung',
            errorUploadingFile: 'Error mengunggah file',
            scoreError: {
                invalid: 'Skor harus berupa angka yang valid',
                range: 'Skor harus 0 atau lebih besar',
                wholeNumber: 'Skor harus berupa bilangan bulat'
            },
            approvalError: {
                invalid: 'Persetujuan harus berupa angka yang valid',
                range: 'Persetujuan harus antara 0 dan 100',
                wholeNumber: 'Persetujuan harus berupa bilangan bulat'
            },
            selectStatus: 'Pilih Status',
            selectCreditType: 'Pilih Jenis Kredit',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Standar',
            browse: 'Jelajahi',
            currencyPlaceholder: 'USD',
            selectFile: 'Pilih File',
            dragDropFiles: 'Seret dan lepas file di sini',
            hideDetails: 'Sembunyikan Detail',
            viewDetails: 'Lihat Detail',
            website: 'Situs Web',
            month: 'Bulan',
            year: 'Tahun',
        },

        error: 'Error',
        success: 'Berhasil',
        remove: 'Hapus',

        projectInfo: {
            title: 'Informasi Proyek',
            organizationDetail: 'Detail Organisasi',
            subOrganizations: 'Sub-Organisasi',
            search: 'Cari',
            organizations: 'Organisasi',
            users: 'Pengguna',
            registrationDate: 'Tanggal Pendaftaran',
            close: 'Tutup',
            country: 'Negara',
            organizationsAddress: 'Alamat Organisasi',
            blockchainAddress: 'Alamat Blockchain',
            creditType: 'Jenis Kredit',
            projectType: 'Jenis Proyek',
            officeName: 'Nama Kantor',
            contactPersonName: 'Nama Kontak',
            contactNumber: 'Nomor Kontak',
            email: 'Email',
            address: 'Alamat',
            website: 'Situs Web',
            vintageYear: 'Tahun Vintage',
            estimatedCredits: 'Kredit Estimasi',
            pricePerCredit: 'Harga Per Kredit',
            module: 'Modul',
            recurring: 'Berulang',
            score: 'Skor',
            approval: 'Persetujuan',
            responsibleDimitraOffice: 'Kantor Dimitra yang Bertanggung Jawab',
            status: 'Status',
            standardMethodology: 'Standar/Metodologi',
            validationDocumentation: 'Dokumentasi Validasi',
            creditStart: 'Mulai Kredit',
            creditEnd: 'Akhir Kredit',
            attachmentTitle: 'Lampiran',
            sdgsTitle: 'Tujuan Pembangunan Berkelanjutan (SDGs)',
            dataCollectionTitle: 'Siklus Pengumpulan Data',
            dataCollectionInfo: 'Untuk berpartisipasi dalam Program Kredit Karbon, petani harus menyediakan data historis pertanian selama pendaftaran dan terus mengirimkan pembaruan data berkala selama program tetap aktif. Ini memastikan pelacakan kinerja karbon yang akurat dari waktu ke waktu.',
            vintage: 'Vintage',
            moduleName: 'Nama Modul',
            futureData: 'Pengumpulan Data Berulang Masa Depan',
            estimatedCredit: 'Kredit Estimasi',
        },

        user: {
            title: 'Pengguna Kredit Karbon',
            selectOrganization: 'Pilih Organisasi',
            selectProject: 'Pilih Proyek',
            allUsers: 'Semua Pengguna',
            activeUsers: 'Pengguna Aktif',
            deactivatedUsers: 'Pengguna Dinonaktifkan',
            pendingUsers: 'Pengguna Menunggu',
            search: 'Cari',
            farmerName: 'Nama Petani',
            farmName: 'Nama Pertanian',
            organizations: 'Organisasi',
            country: 'Negara',
            projectTitle: 'Judul Proyek',
            registerProject: 'Daftar Proyek Baru',
            actions: 'Aksi',
            noData: 'Tidak ada pengguna ditemukan.',
            view: 'Lihat',
            viewLandPermit: 'Lihat Sertifikat Tanah / Izin',
            edit: 'Edit',
            deactivate: 'Nonaktifkan',
            deactivateUser: 'Nonaktifkan Pengguna',
            deactivateConfirmation: 'Apakah Anda yakin ingin menonaktifkan pengguna ini?',
            activate: 'Aktifkan',
            activateUser: 'Aktifkan Pengguna',
            activateConfirmation: 'Apakah Anda yakin ingin mengaktifkan pengguna ini?',
            deactivatedSuccessfully: 'Pengguna berhasil dinonaktifkan',
            activatedSuccessfully: 'Pengguna berhasil diaktifkan',
            deactivationFailed: 'Gagal menonaktifkan pengguna',
            exportAsPdf: 'Ekspor sebagai PDF',
            projectDetails: 'Detail Proyek',
            dateJoined: 'Tanggal Bergabung',
            cropGrowingPractice: 'Praktik Budidaya Tanaman',
            farm: 'Pertanian',
            rejectAll: 'TOLAK SEMUA',
            acceptAll: 'TERIMA SEMUA',
            confirmRejectAll: 'Anda akan menolak permintaan untuk semua pertanian bergabung dengan proyek kredit karbon. Tindakan ini akan mengecualikan setiap pertanian yang diajukan oleh petani dalam permintaan ini. Apakah Anda yakin ingin melanjutkan?',
            confirmAcceptAll: 'Anda akan menerima permintaan untuk semua pertanian bergabung dengan proyek kredit karbon. Tindakan ini akan menyertakan setiap pertanian yang diajukan oleh petani dalam permintaan ini. Apakah Anda yakin ingin melanjutkan?',
            dateOfRegistration: 'Tanggal Pendaftaran',
            farmRegistrationId: 'ID Pendaftaran Pertanian',
            dimitraFarmId: 'ID Pertanian Dimitra',
            notTheFarmer: "Saya bukan Petani",
            farmerFirstName: 'Nama Depan Petani',
            farmerMiddleName: 'Nama Tengah Petani',
            farmerLastName: 'Nama Belakang Petani',
            farmerRegistrationId: 'ID Pendaftaran Petani',
            dimitraFarmerId: 'ID Petani Dimitra',
            farmGeofence: 'Geofence Pertanian',
            viewGeofence: 'Lihat Geofence',
            totalFarmSize: 'Ukuran Total Pertanian',
            mainGoals: 'Apa Tujuan Utama Anda',
            ownershipType: 'Jenis Kepemilikan',
            certifications: 'Sertifikasi',
            productionType: 'Jenis Produksi',
            landTitle: 'Sertifikat Tanah',
            farmLocationAddress: 'Alamat Lokasi Pertanian',
            farmCoordinate: 'Koordinat Pertanian',
            farmerAgreement: 'Perjanjian Petani',
            viewSignedAgreement: 'Lihat perjanjian yang ditandatangani yang diajukan dengan aplikasi.',
            viewAgreement: 'LIHAT PERJANJIAN',
            acceptanceStatus: 'Status Penerimaan',
            currentStatus: 'Status Saat Ini',
            reject: 'TOLAK',
            accept: 'TERIMA',
            farmActivitySubmissions: 'Pengajuan Aktivitas Pertanian',
            farmActivitySubmissionsDesc: 'Catatan yang diajukan dari praktik pertanian dan pembaruan yang diperlukan untuk verifikasi kredit karbon.',
            viewFarmData: 'LIHAT DATA PERTANIAN',
            farmData: 'Data Pertanian',
            farmDataDesc: 'Buat laporan Anda dengan mengintegrasikan data produksi dari berbagai sumber. Pilih satu atau beberapa sumber untuk menyusun daftar lengkap tempat produksi untuk laporan Anda.',
            crops: 'Tanaman',
            sowing: 'Penanaman',
            seedling: 'Bibit',
            fertilizer: 'Pupuk',
            fertilizerError: 'Pengajuan tidak lengkap: Informasi pupuk untuk 4 bulan hilang dari entri petani.',
            harvesting: 'Panen',
            livestock: 'Ternak',
            equipment: 'Peralatan',
            projectRequests: 'Permintaan Proyek',
            userNameAndId: 'Nama Pengguna dan ID',
            email: 'Email',
            userRole: 'Peran Pengguna',
            status: 'Status',
            userRegistrationDate: 'Tanggal Pendaftaran Pengguna',
            pending: 'Menunggu',
            deactivated: 'Dinonaktifkan',
            active: 'Aktif',
            selectProjectTypeFirst: 'Pilih Jenis Proyek Terlebih Dahulu',
        },
    }
} 